/** Small pure geometry helpers for the runner. Axes: +X right, +Y up, +Z forward. */

export function rangesOverlap(aMin: number, aMax: number, bMin: number, bMax: number): boolean {
  return aMin < bMax && aMax > bMin;
}

/** True if a center point is inside an axis-aligned box given by center+half-extents. */
export function pointInBox(
  px: number,
  pz: number,
  py: number,
  cx: number,
  cz: number,
  halfW: number,
  halfD: number,
  minY: number,
  maxY: number,
): boolean {
  return (
    px >= cx - halfW &&
    px <= cx + halfW &&
    pz >= cz - halfD &&
    pz <= cz + halfD &&
    py >= minY &&
    py <= maxY
  );
}
